import { cn } from "@/lib/utils";

const statusColor = {
  ok: "bg-ok",
  progress: "bg-warn",
  risk: "bg-risk",
} as const;

export type StatusDotStatus = keyof typeof statusColor;

interface StatusDotProps {
  status: StatusDotStatus;
  pulse?: boolean;
  className?: string;
}

export function StatusDot({ status, pulse = false, className }: StatusDotProps) {
  return (
    <span className={cn("relative inline-flex size-[13px] shrink-0", className)}>
      {pulse && (
        <span
          className={cn(
            "absolute inset-0 animate-ping rounded-full opacity-60",
            statusColor[status],
          )}
        />
      )}
      <span
        className={cn(
          "relative inline-block size-full rounded-full ring-[3px] ring-white",
          statusColor[status],
        )}
      />
    </span>
  );
}
